import {
	CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS, LOGOUT, PAGE_SHIFT_SOLICITOR_ARTICLES, RECEIVE_ARTICLES_MESSAGE,
	RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE,
	RECEIVE_FAILED_RESPONSE_GET_ARTICLES, RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
	RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS, RECEIVE_GET_ARTICLES,
	RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
	REQUEST_ARTICLES_MESSAGE,
	REQUEST_GET_ARTICLES, REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE
} from "../actions/index";


const defaultState = {
	articles: [],
	selectedView: 20,
	pageArticles: [],
	page: 1,
	featuredArticles: [],
	totalBoxes: 1,
	openModal: false,
	articleInModal: {},
	fetching: false,
	suggestions: [],
	selectedSuggestions: [],
	value: '',
	infoMessage: '',
	fetchingInfoMessage: false,
	badRequestInfoMessage: '',
	totalRecords: 0,
	homePageArticles: [],
	documentToDownload: {},
	fetchingDocument: false,
	failedToGetDocumentMsg: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: true,
				infoMessage: ''
			};
		case RECEIVE_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: false,
				infoMessage: action.payload.body
			};
		case RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE:
			return{
				...state,
				fetchingInfoMessage: false,
				badRequestInfoMessage: action.payload
			};
		case REQUEST_GET_ARTICLES:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_ARTICLES:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.selectedView));
			let currentPage = state.page;
			if(state.page > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				fetching: false,
				articles: action.payload.data,
				totalBoxes: totalDisplayBoxes,
				totalRecords: action.payload.totalRecords,
				page: currentPage
			};
		case RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS:

			return {
				...state,
				suggestions: action.payload.data
			};
		case RECEIVE_FAILED_RESPONSE_GET_ARTICLES:
			return {
				...state,
				fetching: false
			};
		case REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE:

			return {
				...state,
				homePageArticles: action.payload.data
			};
		case RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE:
			return {
				...state,
				fetching: false
			};
		case CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS:
			return {
				...state,
				[action.payload.key]: action.payload.value,
			};
		case PAGE_SHIFT_SOLICITOR_ARTICLES:
			if (action.payload.direction === 'left' && state.page > 1)
				return {
					...state,
					page: state.page - 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else if (action.payload.direction === 'right' && state.page < state.totalBoxes)
				return {
					...state,
					selectedArticles: [],
					selectedAllArticles: false,
					page: state.page + 1,
					totalBoxes: action.payload.totalPaginationBoxes
				};
			else return {
					...state,
					selectedArticles: [],
					selectedAllArticles: false,
					totalBoxes: action.payload.totalPaginationBoxes
				};
		case LOGOUT:
			return {
				...defaultState
			};
		default :
			return state
	}
}